import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { testUrl } from "../home/BaseData";
import ParticlesConfig from "../../shared/components/particles/particles-config";
import classes from "./AnnounceParams.module.css";
import moment from "moment";

import classerror from "../../shared/pages/Error404Page.module.css";
import Error404Animation from "../../shared/assets/animated-placeholders/Error404.json";
import LottieView from "lottie-react";

const AnnounceParams = () => {
    const { announcementId } = useParams();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [announcement, setAnnouncement] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        axios
            .get(`${testUrl}/api/announcements/${announcementId}/`)
            .then((response) => {
                setAnnouncement(response.data);
            })
            .catch((error) => {
                console.error("Error fetching announcement details:", error);
            })
            .finally(() => setLoading(false));
    }, [announcementId, i18n.language]);

    if (loading) {
        return (
            <div className={classes.loadingContainer}>
                <div className={classes.loader}></div>
            </div>
        );
    }

    if (!announcement) {
        return (
            <div className={classerror["error-page"]}>
                <LottieView
                    className={classerror["animation"]}
                    animationData={Error404Animation}
                    loop={true}
                />
                <p className={classerror["title"]}>
                    {t("announcement_not_found")}
                </p>
                <div onClick={() => navigate("/announce")} className={classerror["button"]}>
                    {t("back_to_announcements")}
                </div>
            </div>
        );
    }

    const title = announcement[`title_${i18n.language}`] || announcement.title_uz;
    const content = announcement[`full_announcement_${i18n.language}`] || announcement.full_announcement_uz;

    return (
        <div className={classes.wrapper}>
            <div className={classes.container}>
                <div className={classes.breadcrumb}>
                    <span onClick={() => navigate("/")}>{t("main_menu")}</span>
                    <span className={classes.separator}>/</span>
                    <span onClick={() => navigate("/announce")}>{t("announcementsTitle")}</span>
                    <span className={classes.separator}>/</span>
                    <span className={classes.active}>{t("announcement_detail")}</span>
                </div>

                <div className={classes.detailCard}>

                    <div className={classes.contentSection}>
                        <h1 className={classes.title}>{title}</h1>

                        <div className={classes.metaInfo}>
                            <div className={classes.metaItem}>
                                <span className={classes.label}>{t("published")}:</span>
                                <span className={classes.value}>
                                    {moment(announcement.holding_date).format("LLLL")}
                                </span>
                            </div>
                            {announcement.finishing_time && (
                                <div className={classes.metaItem}>
                                    <span className={classes.label}>{t("deadline")}:</span>
                                    <span className={classes.value}>
                                        {moment(announcement.finishing_time).format("LLLL")}
                                    </span>
                                </div>
                            )}
                        </div>

                        <div
                            className={classes.richContent}
                            dangerouslySetInnerHTML={{ __html: content }}
                        />

                        <div className={classes.footer}>
                            <button
                                className={classes.backButton}
                                onClick={() => navigate("/announce")}
                            >
                                {t("back_to_announcements")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AnnounceParams;
